import api from "@/services/api/axios-client";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CreatePreferenceDto } from "generated";

export const usePreferenceMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (createPreferenceDto: CreatePreferenceDto) =>
      api.preferenceControllerCreateOrUpdate({ createPreferenceDto }),
    onSuccess: (result) => {
      queryClient.setQueryData(["user-preference"], result.data);
    },
  });
};

export const usePreferenceQuery = () => {
  return useQuery({
    queryKey: ["user-preference"],
    queryFn: async () =>
      api.preferenceControllerFindOne().then((res) => res.data),
  });
};
